import { PROPERTY_TYPE_OFFICE, PROPERTY_TYPE_OTHER } from '../../components/book/Property/Fields/FieldsConsts';

export default {
  SERVICE: {
    heading: 'Choose what you need and book a move online.',
    subheading: 'We offer affordable options customizable to your needs.',
    helper: null,
  },
  LOCATIONS: {
    heading: 'Please enter your information.',
    subheading: null,
    helper: null,
  },
  PROPERTIES: {
    heading: 'Confirm the details for your locations.',
    subheading: 'Please adjust location details if necessary.',
    helper: '<span>Note:</span> Fields with an <span>*</span> are required',
    alerts: {
      [PROPERTY_TYPE_OFFICE]:
        'Estimating this type of move may require some special attention from our team. Please call 844-420-1024 to chat with one of our sales agents.',
      [PROPERTY_TYPE_OTHER]:
        'Estimating this type of move may require some special attention from our team. Please call 844-420-1024 to chat with one of our sales agents.',
    },
  },
  INVENTORY: {
    heading: 'Which rooms will we be moving for you?',
    subheading: 'Detailed inventory helps us make sure we have the right people for the job.',
    helper: null,
  },
  SPECIAL_INVENTORY: {
    heading: 'Do you need help moving any of these items?',
    subheading: 'Detailed inventory helps us make sure we have the right people for the job.',
    helper: null,
  },
  DATE: {
    heading: 'Choose the date of your move.',
    subheading: 'You can reschedule after booking if necessary.',
    helper: null,
  },
  TIME: {
    heading: null,
    subheading: 'Pick a time that’s best for your schedule.',
    helper: null,
  },
  HOURLY: {
    heading: 'Let us know what you need, we got you.',
    subheading: `For items weighing +200 lbs, please reserve 3 pros. For more details on heavy items, refer to our <a target='_blank' rel='noreferrer' href='/terms-of-service'>Terms of Service</a>.`,
    helper: null,
  },
  PACKAGE: {
    heading: 'We recommend this plan for your move.',
    subheading: 'After 300,000 moves, we feel confident about our recommendation.',
    helper: null,
  },
  PACKAGE_FOR_FIXED_PRICING: {
    heading: 'You Qualify for Our Guaranteed Pricing!',
    subheading: 'Based on your information, here is your all inclusive price:',
    helper: null,
  },
  FLEXIBILITY: {
    heading: null,
    subheading: null,
    helper: null,
  },
  ADDONS: {
    heading: 'Do you need anything else?',
    subheading: 'You can add these any time after you reserve.',
    helper: null,
  },
  CHECKOUT: {
    heading: null,
    subheading: null,
    helper: null,
  },
  LDM_LEAD: {
    heading: `Looks like you're moving to another city.`,
    subheading:
      'We move thousands of families to a new city each year. Just enter your contact information, and a member of our concierge team will get in touch to build you a customized plan and get you a guaranteed quote for your move.',
    helper: null,
  },
  LDM_LEAD_CONFIRMATION: {
    heading: `Thanks. We'll be in touch soon.`,
    subheading: `Expect a call from our concierge team within one business day. We'll talk through your move details and then provide any available options.`,
    helper: null,
  },
  LEAD: {
    heading: `Looks like we don't service your location yet.`,
    subheading: 'Send us your contact info, and we will let you know when we can move you!',
    helper: '<span>Quick tip:</span> Fields with an <span>*</span> are required',
  },
  LEAD_CONFIRMATION: {
    heading: `Thanks. We'll be in touch soon.`,
    subheading: `Expect a call from our concierge team within one business day. We'll talk through your move details and then provide any available options.`,
    helper: null,
  },
  LABOR_ONLY_NOTICE: {
    // should I add line breaks where they appear in the mockup?
    heading: `It looks like we don't have trucks in your area yet but we're working on it.`,
    subheading: `But we can provide movers if you provide your own truck. Click continue to book a Movers only service.`,
    helper: null,
  },
  PRIVACY_MODAL_BODY:
    'At Bellhop, privacy is a priority. While booking this move, we will collect your name, phone number, email address, physical address, payment information, and any other data you decide to share with us to set your move up for success. We use this information to provide the requested moving services, improve the customer experience, collect payment, and market products and services to you. Bellhop does not sell your information. You can review our privacy policy at www.getbellhop.com/privacy-policy.',
};
